import cx from 'classnames';
import React, { useState } from 'react';
import {
  Button,
  CardAction, Navbar,
  ShortDesc,
  Sidebar,
  Spacer
} from '../../components';

function Reverse() {

  const [closeSide, setCloseSide] = useState(false)

  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }


  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })

  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            <CardAction />
            <div className="row">
              <div className="col-xl-7">
                <Spacer h={20} />
                <div className="cardContainer">
                  <ShortDesc desc="Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda, veritatis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda, veritatis?" />
                </div>
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="formGroup">
                    <div className="mb-3 row">
                      <div className="col-sm-8 mb-2">
                        <input type="text" className="form-control form-control-lg custom-input" id="inspect_creator" placeholder="Creator address (reverse)" />
                      </div>
                      <div className="col-sm-4 mb-2">
                        <select className="form-select form-select-lg custom-input">
                          <option value="">Network</option>
                          <option value="1">Network 1</option>
                          <option value="2">Network 2</option>
                          <option value="3">Network 3</option>
                        </select>
                      </div>
                    </div>
                    <Button label="Add To Watchlist" varian="orange light" />
                    <Spacer h={20} />
                    <div className="filterTransaction row align-items-center">
                      <span className="col-lg-4">Filter Transaction</span>
                      <div className="col-lg-8 d-flex">
                        <Button label="Lvl 1 (10)" varian="orange light" />
                        <Spacer w={10} />
                        <Button label="Lvl 2 (10)" varian="orange light" />
                        <Spacer w={10} />
                        <Button label="Lvl 3 (10)" varian="orange light" />
                        <Spacer w={10} />
                        <Button label="Lvl 4 (10)" varian="orange light" />
                      </div>
                    </div>
                    <Spacer h={20} />
                    <div className="filterTransaction row align-items-center">
                      <span className="col-lg-4">Total related wallet</span>
                      <div className="col-lg-8 d-flex align-items-center">
                        <input type="text" placeholder="0" className="form-control form-control-lg w-25 custom-input" />
                        <span className="ms-3">wallets</span>
                      </div>
                    </div>
                  </div>
                </div>
                <Spacer h={20} />
                <div className="cardContainer">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Contract Address</th>
                        <th>Simbol</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae, perferendis.</td>
                        <td>SIMBOL</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae, perferendis.</td>
                        <td>SIMBOL</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-xl-5">
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="cardUtil">
                    <span className="titleCard d-block">Creator Watchlist</span>
                  </div>
                  <div className="table-responsive tableScroll scrollCustom" style={{ height: 440 }}>
                    <table className="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Address 1</td>
                        </tr>
                        <tr>
                          <td>Address 2</td>
                        </tr>
                        <tr>
                          <td>Address 3</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <Spacer h={20} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Reverse

